import {
  useDeleteRadio,
  useRadio,
  useUpsertPerson,
  useUpsertRadio,
  useUserInfo,
} from '@/hooks';
import { isAuthorised } from '@/utils';
import { Box } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router';
import { RadioForm } from './RadioForm';

const DEFAULT_RADIO = { label: '' };

export function Radio() {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const {
    query: { data: fetchedRadio },
  } = useRadio(id);
  const radio = id === 'new' ? DEFAULT_RADIO : fetchedRadio;
  const { mutate: upsertRadio } = useUpsertRadio();
  const { mutate: upsertPerson } = useUpsertPerson();
  const { mutate: deleteRadio } = useDeleteRadio();
  const {
    query: { data: userInfo },
  } = useUserInfo();
  const canEdit = isAuthorised(userInfo?.authorisation, 'people', true);

  function handleDelete() {
    deleteRadio(id, {
      onSuccess: () => {
        navigate('..', { replace: true });
      },
    });
  }

  function handleSubmit(values) {
    upsertRadio(values, {
      onSuccess: (data) => {
        navigate(`../${data.ssi}`, { replace: true });
      },
    });
  }

  function handleRemove(id) {
    upsertPerson(
      { _id: id, radioSsi: null },
      {
        onSuccess: () =>
          queryClient.invalidateQueries({ queryKey: ['radios'] }),
      },
    );
  }

  return (
    <Box sx={{ flexGrow: 1, p: 1, bgcolor: 'background.paper' }}>
      <title>
        {['IR3', 'Radios', radio?._id ? radio?.ssi : 'New Radio']
          .filter(Boolean)
          .join(' | ')}
      </title>
      <RadioForm
        key={[radio?._id, radio?.lastEdit?.time]}
        defaultValues={radio}
        canEdit={canEdit}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
        onRemove={handleRemove}
      />
    </Box>
  );
}
